export enum Product {
  Undefined = 0,
  LiveChat,
  HelpDesk,
  KnowledgeBase,
  ChatBot,
  OpenWidget,
  Platform,
  PartnerProgram,
  TextApp,
  Accounts,
}

export type ProductAccess = {
  name: string;
  haveAccessToProduct: boolean;
  canJoinProduct: boolean;
};

type ProductOrImgUrl =
  | {
      product: Product;
    }
  | {
      imgUrl: string;
    };

export type ProductCard = ProductOrImgUrl & {
  name: string;
  description: string;
  link?: string;
  product?: Product;
  imgUrl?: string;
};
